import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { H4 } from 'UIComponents/elements/headings';
import UIButton from 'UIComponents/button/UIButton';
import usageTracker from 'flow-doctor-lib/usageTracker';
import EnrollmentEventTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/EnrollmentEventTimelineItemLabel';
import { Popover } from 'foundations-components/transitional/components/Popover';
import useInstanceCount from 'flow-doctor-lib/hooks/useInstanceCount';
import { getValueFromLocalStorage, setValueInLocalStorage } from 'flow-doctor-lib/utils/localStorage';
import FlowDoctorHandlerContext from 'flow-doctor-lib/context/FlowDoctorHandlerContext';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentLogEventTimelineItemLabel = ({
  logItem
}) => {
  const enrollmentLog = logItem.data;
  const {
    onDiagnose
  } = React.useContext(FlowDoctorHandlerContext);
  const [showDiagnosticShepherd, setShowDiagnosticShepherd] = React.useState(false);
  const instanceCountAtMount = useInstanceCount({
    instanceKey: enrollmentLog.type
  });
  React.useEffect(() => {
    if (onDiagnose && !getValueFromLocalStorage('has-seen-diagnose-shepherd') && instanceCountAtMount === 1) {
      setShowDiagnosticShepherd(true);
    }
  }, [onDiagnose, instanceCountAtMount]);
  switch (enrollmentLog.type) {
    case 'ENROLLMENT':
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(EnrollmentEventTimelineItemLabel, {
            enrollmentLog: enrollmentLog
          }), onDiagnose && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Popover, {
              use: "shepherd",
              inlineSize: "350px",
              open: showDiagnosticShepherd,
              showCloseButton: true,
              onOpenChange: evt => {
                setValueInLocalStorage('has-seen-diagnose-shepherd', 'true');
                setShowDiagnosticShepherd(evt.target.value);
              },
              placement: "left",
              autoPlacement: false,
              closeOnOutsideClick: false,
              content: {
                header: /*#__PURE__*/_jsx(H4, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "flow-doctor-lib.flows.objectLifecycle.diagnoseShepherd.title"
                  })
                }),
                body: /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "flow-doctor-lib.flows.objectLifecycle.diagnoseShepherd.description"
                  })
                })
              },
              children: /*#__PURE__*/_jsx(UIButton, {
                use: "primary",
                size: "xs",
                onClick: () => {
                  usageTracker.track('pageAction', {
                    objectTypeId: enrollmentLog.objectTypeId,
                    actionType: 'CLICK_DIAGNOSE'
                  });
                  onDiagnose(enrollmentLog);
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "flow-doctor-lib.flows.objectLifecycle.diagnoseEnrollment"
                })
              })
            })
          })]
        });
      }
    case 'UNENROLLMENT':
      {
        if (enrollmentLog.enrollmentState === 'FAILED') {
          if (enrollmentLog.failType) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: `flow-doctor-lib.flows.objectLifecycle.events.UNENROLLMENT.failType.${enrollmentLog.failType}`
            });
          }
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.genericUnenrollmentFailure"
          });
        }
        if (enrollmentLog.unenrollType) {
          if (enrollmentLog.unenrollType === 'MANUAL_UNENROLL') {
            if (enrollmentLog.contextMap.USER_ID) {
              return /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: `flow-doctor-lib.flows.objectLifecycle.events.UNENROLLMENT.${enrollmentLog.unenrollType}.byUser`,
                options: {
                  userName: /*#__PURE__*/_jsx(UserNameLabel, {
                    userId: enrollmentLog.contextMap.USER_ID
                  })
                }
              });
            }
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: `flow-doctor-lib.flows.objectLifecycle.events.UNENROLLMENT.${enrollmentLog.unenrollType}.generic`
            });
          }
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: `flow-doctor-lib.flows.objectLifecycle.events.UNENROLLMENT.${enrollmentLog.unenrollType}`
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.objectLifecycle.genericUnenrollment"
        });
      }
    case 'PRE_ENROLLMENT':
      return /*#__PURE__*/_jsxs("div", {
        children: [enrollmentLog.triggerEnrollType && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `flow-doctor-lib.flows.objectLifecycle.events.PRE_ENROLLMENT.enrollType.${enrollmentLog.triggerEnrollType}`
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `flow-doctor-lib.flows.objectLifecycle.events.PRE_ENROLLMENT.${enrollmentLog.filterEventType}`
        })]
      });
    default:
      throw new Error('Unexpected EnrollmentHistoryLogEvent type');
  }
};
export default EnrollmentLogEventTimelineItemLabel;